import { updateUserCount, updateProjectCount } from '@shared/site-stats-counter';
import Callout from '@shared/ui-callout';

// Make the callout for the site stats total projects explanation
const triggerEl = document.getElementById('posted-listings');
new Callout(triggerEl);

// Set the new registered users and total jobs posted count
const registeredUsersCount =
  document.getElementById('footerRegisteredUsersCount');
const totalJobsPostedCount =
  document.getElementById('footerTotalJobsPostedCount');

updateUserCount(registeredUsersCount);
updateProjectCount(totalJobsPostedCount);
